export default __webpack_public_path__ + "static/media/pic3.0383de22.png";